import { useGetFrontCategorie } from '@framework/api-client';
import { useAuth } from '@framework/auth';
import { t } from '@framework/i18n';
import { generatePath } from '@framework/ui';
import { useMemo } from 'react';
import { type MenuItemsProps } from './MainMenu';

export function useMainMenuItem(): MenuItemsProps[] {
  // Le voci private compaiono solo a login completato: durante la selezione
  // "per conto di" l'utente è ancora `isPrelogged` ma non `isLogged`.
  const { isLogged } = useAuth();

  const { data } = useGetFrontCategorie();

  const result = useMemo(() => {
    const categoryMenus = data?.dati ?? [];

    const result: MenuItemsProps[] = [
      {
        menuKey: 'domande',
        to: '/domande',
        children: t('menu.tutte-le-domande', 'Tutte le Domande'),
        title: t('menu.tutte-le-domande.sr-title', 'Vai a Tutte le Domande'),
      },
    ];

    if (categoryMenus?.length > 0) {
      result.push(
        ...(categoryMenus
          .filter(category => category.creaMenuCategoria)
          .map(category => ({
            menuKey: `category-${category.id}`,
            to: generatePath('/categoria/:categoryId', {
              categoryId: String(category.id),
            }),
            children: category.etichetta,
            title: t(
              'menu.category.sr-title',
              'Vai a Domande nella categoria {{category}}',
              { category: category.etichetta },
            ),
          })) ?? []),
      );
    }
    if (isLogged) {
      result.push({
        menuKey: 'richieste',
        to: generatePath('/richieste', {}),
        children: t('menu.le-mie-richieste', 'Le mie Richieste'),
        title: t('menu.le-mie-richieste.sr-title', 'Vai a Le mie Richieste'),
      });
    }

    return result;
  }, [isLogged, data]);

  return result;
}
